/**
@format
@flow
*/

type FilterArraySingle = Array<string>;

type FilterArrayObject = Array<{ name: string, _id: string }>;

type FilterObject = {
  [fieldName: string]: FilterArraySingle | FilterArrayObject,
};

// For findField()
type Content = string;

/**
 * HELPER FUNCTION TO GRAB LENGTH OF ALL FILTERS APPLIED
 * USED IN DISCOVER & CHANNEL PAGES
 */
const getTotalFilters = (filterArray: FilterArraySingle,
  limit?: number = 0): Array<string> => {
  const newArray = filterArray.reduce(
    (prevItem, current) => prevItem.concat(
      Array.isArray(current) ? getTotalFilters(current, limit ? limit - 1 : 0) : current,
    ), [],
  );

  if (limit) {
    return newArray.slice(0, limit);
  }

  return newArray;
};

/**
 * HELPER FUNCTION TO FILTER FILTERS IN REDUCER
 * USED IN DISCOVER & FILTER REDUCERS
 */
const getNewFiltersResults = (filters: FilterObject, filterAction: string): FilterObject => {
  let newFilterResults = filters ?? {};

  Object.keys(filters).forEach((field) => {
    if ((filters[field] || []).includes(filterAction)) {
      newFilterResults = {
        ...filters,
        [field]: filters[field].filter(
          (item) => item !== filterAction,
        ),
      };
    }
  });

  return newFilterResults;
};

/**
 * TRAVERSE FILTER SERVICE OBJECT TO GRAB THE FIELD ID FROM CONTENT PASSED IN
 */
const findField = (service: FilterObject, content: Content): string => {
  let toReturn = '';
  Object.keys(service).forEach((key) => {
    if ((service?.[key] || []).some(
      (filter) => (filter?.name ? filter?.name === content : filter === content),
    )) {
      toReturn = key;
    }
  });
  return toReturn;
};

export { getTotalFilters, getNewFiltersResults, findField };
